<template>
    <div>
        <div
            class="mapouter mt-3"
            style="margin-left: 24px; margin-right: 24px;"
        >
            <!-- <v-layout row>
                <v-flex md12>
                    <l-map
                        style="height: 300px; border: 2px #43a047 solid;"
                        :zoom="map.zoom"
                        :center="map.center"
                        class="route-marker"
                    >
                        <v-tilelayer-googlemutant :apikey="map.apiKey">
                        </v-tilelayer-googlemutant>
                        <l-marker
                            v-if="lastScanLocations.length"
                            v-for="location in lastScanLocations"
                            :icon="map.icon"
                            :lat-lng="location.markerLatLng"
                            ><l-popup
                                ><div class="route-marker-title">
                                    {{ location.route }}
                                </div>
                                <div>{{ location.gpsAddress }}</div>
                            </l-popup></l-marker
                        >
                    </l-map></v-flex
                >
            </v-layout> -->
        </div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            :actions="actions"
            :beforeSetupGrid="beforeSetupGrid"
            :onLoaded="onLoaded"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            ref="grid"
        ></dx-grid></div
></template>
<script>
import moment from "moment";
import * as firebase from "firebase/app";
import "firebase/database";
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
//import L from "leaflet";
import { latLng, icon } from "leaflet";
import Vue2LeafletGoogleMutant from "vue2-leaflet-googlemutant";

export default {
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LPopup,
        "v-tilelayer-googlemutant": Vue2LeafletGoogleMutant,
    },
    data: () => ({
        title: "Scans",

        map: {
            //url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
            //https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png
            //http://{s}.tile.osm.org/{z}/{x}/{y}.png
            zoom: 14,
            center: latLng(40.700352, -73.9538212), //[40.700352, -73.9538212],
            icon: icon({
                iconUrl:
                    "https://iconsplace.com/wp-content/uploads/_icons/ff0000/256/png/truck-icon-14-256.png",
                iconSize: [20, 20],
            }),
            apiKey: "AIzaSyBiKL7s59GqA2vu331EbCvngDC7LzEs81s",
        },

        columns: [
            {
                label: "Family ID",
                field: "familyID",
                visible: true,
                link: "FoodDistributionFamilyView",
                format: "",
                template: "link-cell-template",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "First Name",
                field: "firstName",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Name",
                field: "lastName",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "ScanDate",
                field: "scanDate",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                sortOrder: "desc",
                sortIndex: 0,
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "GPS Address",
                field: "gpsAddress",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "User ID",
                field: "userID",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Device ID",
                field: "deviceID",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Scan Type",
                field: "scanType",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Address",
                field: "address",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Truck",
                field: "truck",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Box Size",
                field: "boxSize",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Route",
                field: "route",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Label Batch",
                field: "labelBatch",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Box Number",
                field: "boxNum",
                visible: true,
                type: "number",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Of Boxes",
                field: "ofBoxes",
                type: "number",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },

            {
                label: "Sort",
                field: "sort",
                visible: true,
                filterValues: [],
                // sortOrder: "asc",
                // sortIndex: 0,
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date Created",
                field: "dateCreated",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Scheduled Delivery Date",
                field: "scheduledDeliveryDate",
                type: "date",
                format: "MM/dd/yyyy",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Alerted Date",
                field: "alertedDate",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Street",
                field: "street",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "House",
                field: "house",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Street Side",
                field: "streetSide",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Bus Apt",
                field: "busApt",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Bus State",
                field: "busState",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Home Phone",
                field: "homePhone",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Cell Phone",
                field: "cellPhone",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],

        actions: [],
        url: "",
        user: "",
        processing: false,
        firebaseRef: "",
        selectedDistribution: "",
        intervalID: "",
        lastScanAddress: "",
        lastScanLocations: [],
    }),
    created() {},
    mounted() {
        if (this.$refs && this.$refs.grid) {
            this.firebaseSetup();
        }

        this.intervalID = setInterval(() => {
            if (this.$refs && this.$refs.grid) {
                this.$refs.grid.reloadGrid();

                this.updateLastScanLocations();
            }
        }, 60000);
    },
    beforeDestroy() {
        this.firebaseRef.off();

        clearInterval(this.intervalID);
    },
    methods: {
        onRowClicked(row) {
            this.$router.push({
                name: "FoodDistributionFamilyView",
                params: { id: row.familyID.trim() },
            });
        },
        async beforeSetupGrid() {
            await this.loadDistributions();

            this.selectedDistribution = this.getSavedDistribution()
                ? this.getSavedDistribution()
                : this.distributions[this.distributions.length - 1]
                      .distributionName;

            localStorage.setItem(
                "SelectedDistribution",
                this.selectedDistribution
            );

            this.actions.push({
                text: "Select Distribution",
                align: "left",
                type: "select",
                values: this.distributions.map((d) => d.distributionName),
                value: this.selectedDistribution,
                onSelected: this.onDistributionSelected,
            });

            const distributionID = this.distributions.find(
                (d) => d.distributionName == this.selectedDistribution
            ).distributionID;

            this.url = "foodDistributionScans?distributionID=" + distributionID;

            this.updateLastScanLocations();
        },
        getSavedDistribution() {
            const saved = localStorage.getItem("SelectedDistribution");

            return saved &&
                this.distributions.find((d) => d.distributionName == saved)
                ? saved
                : "";
        },
        async onDistributionSelected(value) {
            const distributionID = this.distributions.find(
                (d) => d.distributionName == value
            ).distributionID;

            this.selectedDistribution = value;

            localStorage.setItem(
                "SelectedDistribution",
                this.selectedDistribution
            );

            this.url = "foodDistributionScans?distributionID=" + distributionID;

            this.$refs.grid.reloadDataSource(this.url);
        },
        async loadDistributions() {
            const response = await this.$http.get(
                "odata/foodWeeklyDistributions?$orderby=dateCreated desc"
            );

            this.distributions = response.value;
        },
        onLoaded(data) {
            if (!data.length) return;

            data.forEach(
                (d) => (d.sort = d.sort ? d.sort.replace(/^0+/, "") : "")
            );

            if (!this.lastScanAddress) {
                const src =
                    "https://maps.google.com/maps?q=google&t=&z=14&ie=UTF8&iwloc=&key=AIzaSyCtYeCL8HkqlMKJh6g6jcDvoH60-woVbDE&output=embed&q=";

                this.lastScanAddress =
                    src + data[0].gpsAddress + ",Brooklyn+NY";
            }
        },
        async updateLastScanLocations() {
            try {
                const distributionID = this.distributions.find(
                    (d) => d.distributionName == this.selectedDistribution
                ).distributionID;

                const lastLocations = await this.$http.get(
                    "/api/FoodDistributionScans/GetLastScanLocations?distributionID=" +
                        distributionID
                );

                this.lastScanLocations = lastLocations
                    .map((location) => {
                        if (location.gps) {
                            const parts = location.gps.split(",");
                            const marker = [
                                parts[0].replace("geo://", ""),
                                parts[1],
                            ];

                            if (marker.every(Boolean)) {
                                location.markerLatLng = marker.map((m) => +m);
                            }
                        }

                        return location;
                    })
                    .filter(
                        (l) => l.markerLatLng && l.markerLatLng.every(Boolean)
                    );

                if (lastLocations && lastLocations.length) {
                    const last = lastLocations[0];

                    const src =
                        "https://maps.google.com/maps?q=google&t=&z=14&ie=UTF8&iwloc=&key=AIzaSyCtYeCL8HkqlMKJh6g6jcDvoH60-woVbDE&output=embed&q=";

                    this.lastScanAddress =
                        src + last.gpsAddress + ",Brooklyn+NY";
                }
            } catch (e) {}
        },
        getGpsAddress(scan) {
            const src =
                "https://maps.google.com/maps?q=google&t=&z=14&ie=UTF8&iwloc=near&key=AIzaSyCtYeCL8HkqlMKJh6g6jcDvoH60-woVbDE&output=embed&q=";

            return src + scan.gpsAddress + ",Brooklyn+NY";
        },
        firebaseSetup() {
            const firebaseConfig = {
                apiKey: "AIzaSyCtYeCL8HkqlMKJh6g6jcDvoH60-woVbDE",
                authDomain: "utaw.firebaseapp.com",
                databaseURL: "https://utaw.firebaseio.com",
                projectId: "project-683582246459980907",
                storageBucket: "project-683582246459980907.appspot.com",
                messagingSenderId: "193425158146",
                appId: "1:193425158146:web:f1ae134a803fb75832371b",
            };

            if (!firebase.apps.length) {
                firebase.initializeApp(firebaseConfig);
            }

            //var database = firebase.database();
            var ref = firebase.database().ref("food-distribution-scans");

            const distributionID = 5;

            const query = ref;

            this.firebaseRef = query;

            query.on(
                "value",
                (snapshot) => {
                    this.$refs.grid.reloadGrid();

                    this.updateLastScanLocations();
                },
                function(error) {
                    console.log("Error: " + error.code);
                }
            );
        },
    },
};
</script>
<style>
.route-marker .leaflet-popup-content {
    margin: 5px 16px;
}
.route-marker-title {
    font-weight: 700 !important;
    font-size: 14px !important;
}
</style>
